export const emailOAuthCallbackErrorMessage = (t, errorCode, provider) => {
  switch (errorCode) {
    case 'email_taken':
      return t('INBOX_MGMT.ADD.EMAIL_CHANNEL.OAUTH.EMAIL_TAKEN');
    case 'feature_unavailable':
      return t('INBOX_MGMT.ADD.EMAIL_CHANNEL.OAUTH.FEATURE_UNAVAILABLE');
    case 'invalid_state':
      return t('INBOX_MGMT.ADD.EMAIL_CHANNEL.OAUTH.INVALID_STATE');
    default:
      if (provider === 'google') {
        return t('INBOX_MGMT.ADD.GOOGLE.ERROR_MESSAGE');
      }
      if (provider === 'microsoft') {
        return t('INBOX_MGMT.ADD.MICROSOFT.ERROR_MESSAGE');
      }
      return t('INBOX_MGMT.ADD.EMAIL_CHANNEL.OAUTH.OAUTH_FAILED');
  }
};
